const STAGE = process.env.NEXT_PUBLIC_STAGE ?? ''

const IS_LOCAL = STAGE === 'local'
const IS_DEV = STAGE === 'dev'

export const getCookieDomain = () => {
  if (IS_LOCAL) {
    return 'localhost'
  }

  if (IS_DEV) {
    return '.testwiggot.com'
  }

  return '.wiggot.com'
}
